import React from 'react';
import {MDXProvider} from '@mdx-js/react';
import {Link} from 'gatsby';
import MapComponent from '../Map';
import Email from '../Email';
import Phone from '../Phone';
import Button from '../Button';
import A from '../Button/a';
import Contact from '../Contact';
import Info from '../Info';
import Categories from '../Categories';
import Products from '../../blocks/Products';
import CategoriesBlock from '../../blocks/CategoriesBlock';
import CategoriesProducts from '../../blocks/CategoriesProducts';

export const components = {
  Products,
  Contact,
  Map: MapComponent,
  A,
  Email,
  Info,
  Button,
  Phone,
  Link,
  CategoriesBlock,
  CategoriesProducts,
  Categories,
};

export const WrapRootElement = ({children}) => (
  <MDXProvider components={components}>{children}</MDXProvider>
);
